const readBool = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined || value === "") return defaultValue;
  return value === "true";
};

export const adsenseConfig = {
  clientId: import.meta.env.VITE_ADSENSE_PUBLISHER_ID ?? "",
  /** Show labeled placeholder boxes instead of loading AdSense (default on). */
  preview: readBool(import.meta.env.VITE_ADSENSE_PREVIEW, true),
  /** Use Google's test ads when loading live units (data-adtest=on). */
  test: readBool(import.meta.env.VITE_ADSENSE_TEST, true),
  /** Master switch — set false to hide all ad slots. */
  enabled: readBool(import.meta.env.VITE_ADSENSE_ENABLED, true),
};

export const isAdsenseConfigured = (): boolean => adsenseConfig.clientId.length > 0;
